import { Injectable } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable, forkJoin } from "rxjs";
import { map, mergeMap } from "rxjs/operators";
import * as _ from 'lodash';
import { FileService, CacheService } from 'mapfre-auditlib';

@Injectable({
   providedIn: "root"
})
export class TaskService {

   className = 'TaskService';
   isNaN: Function = Number.isNaN;

   constructor(private http: HttpClient, private fileService: FileService, private cacheService: CacheService) { }

   getTaskByProgramJobId(programJobId): Observable<any[]> {
      return this.http.get<any[]>(environment.base_URL_GAIA + "/task", { params: { programJobId: programJobId } });
   }

   removeTaskByProgramJobId(programJobId): Observable<any[]> {
      if (_.isArray(programJobId)) {
         programJobId = programJobId.join(',');
      }

      return this.http.delete<any[]>(environment.base_URL + "/tasks", { params: { programJobId: programJobId } });
   }

   removeTaskByGuideJobId(guideJobId): Observable<any[]> {
      if (_.isArray(guideJobId)) {
         guideJobId = guideJobId.join(',');
      }

      return this.http.delete<any[]>(environment.base_URL + "/tasks", { params: { guideJobId: guideJobId } });
   }

   createTask(task): Observable<any[]> {
      return this.http.post<any[]>(environment.base_URL + "/tasks", task);
   }

   updateTask(task): Observable<any[]> {
      return this.http.put<any[]>(environment.base_URL + "/tasks", task);
   }

   saveTask(task): Observable<any[]> {
      return this.http.post<any[]>(environment.base_URL + "/tasks", task);
   }


   getStatusTask(cache = true, cacheKey = "taskStatus"): Observable<any[]> | any {
      if (this.cacheService.canUseCache(cacheKey) && cache) {
         return this.cacheService.getCacheData(cacheKey);
       } else {
         let observable = this.http.get<any[]>(environment.base_URL + "/types-state-nodes").pipe(map((res) => {
         this.cacheService.updateCacheData(res, cacheKey)
         return res;
         }))
         this.cacheService.updateCacheReq(cacheKey);
         return observable;
       }
   }

   newStatusTask(task): Observable<any[]> {
      return this.http.post<any[]>(environment.base_URL + "/types-state-nodes", task);
   }

   updateStatusTask(task, id) {
      return this.http.put(environment.base_URL + `/types-state-nodes/${id}`, task)
   }

   saveTaskWithFile(task): Observable<any[]> {
      // PRE FILES INI — only pick real File instances, not already-uploaded metadata objects
      let filesToUpload = _.remove(_.get(task, 'files'), (f) => f instanceof File);
      // PRE FILES END
      //CHECK IF THERE ARE NEW FILES
      if (!_.isEmpty(filesToUpload)) {
         return this.saveTask(task).pipe(mergeMap((res: any) => {
            let observables: Observable<any[]>[]  = _.map(filesToUpload, (f) => this.fileService.upload(f, 'task', res));
            return forkJoin(observables);
         }))
      }
      else {
         if (task.idTaskPk) {
            return this.saveTask(task);
         }
         else {
            return this.saveTask(task);
         }
      }
   }

   export(task, jobId): Observable<any[]> {
      let params = {
         jobId
      }
      let options = {
         params,
         responseType: "blob" as 'json'
      }
      return this.http.post<any[]>(environment.base_URL_GAIA + "/task/" + task.idTaskPk + "/export", task, options);
   }

   
  /**
   * Calcula el porcentaje de trabajo completado
   * @returns devuelve un numero que se vera reflejado en la barra de progreso
   */
   public calculateProgress(areas): number {
      let totalWeight: number = 0;
       let weightTimesProgress: number = 0;
       if(areas){
         areas.forEach(area => {
           if(area.tareas){
             area.tareas.forEach(tarea => {
               totalWeight += +tarea.taskWeightProgram;
               weightTimesProgress += (tarea.taskWeightProgram * tarea.taskProgressProgram);
             });
           }
            if (area.subareas){
             area.subareas.forEach(subarea => {
               if(subarea.tareas){
                 subarea.tareas.forEach(tareaSub => {
                   totalWeight += +tareaSub.taskWeightProgram;
                   weightTimesProgress += (tareaSub.taskWeightProgram * tareaSub.taskProgressProgram);
                 });
               }
             })
           }
         });
         if(totalWeight ==0 || this.isNaN((weightTimesProgress / totalWeight))){
           return 0;
         }else{
         return +(weightTimesProgress / totalWeight).toFixed(2);
         }
       }
       else{
         return 0;
         } 
      }
}
